import type { AppDispatch } from '@/store';

import { clearChosenCategory } from '@/ducks/voyageInfo/category';
import { clearChosenSubCategory } from '@/ducks/voyageInfo/subCategory';

export const clearChooseCategories = () => (dispatch: AppDispatch) => {
  dispatch(clearChosenSubCategory());
  dispatch(clearChosenCategory());
};
